module.exports = __webpack_public_path__ + "img/oral-hygiene.2762771e.svg";